export const formatMoneda = (valor) => {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  }).format(valor || 0);
};

/** Enteros con punto como miles (ej. 29.200), sin símbolo ni decimales — útil para Excel. */
export const formatNumeroEnteroColombiano = (valor) => {
  const n = Math.round(Number(valor) || 0);
  const neg = n < 0;
  const abs = Math.abs(n);
  const grouped = String(abs).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return neg ? `-${grouped}` : grouped;
};


  